export enum enumOrderStatusType {
    New = 'New',
    CustomOrderReceived = 'CustomOrderReceived',
    PaymentCallPending = 'PaymentCallPending',
    PaymentPending = 'PaymentPending',
    Created = 'Created',
    Approved = 'Approved',
    Preparing = 'Preparing',
    Ready = 'Ready',
    Shipped = 'Shipped',
    Delivered = 'Delivered',
    Cancelled = 'Cancelled'
};

export enum enumOrderStatusId {
    New = 1,
    CustomOrderReceived = 2,
    PaymentCallPending = 3,
    PaymentPending = 4,
    Created = 5,
    Approved = 6,
    Preparing = 7,
    Ready = 8,
    Shipped = 9,
    Delivered = 10,
    Cancelled = 11
};
